import React from 'react';
import styled from '@emotion/styled';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { color, breakpoints } from '../../utils/style';
import line from '../../img/line.svg';
import banner from '../../img/banner.jpg';
import { validateLink } from '../../utils/system';
import dictionary from '../../utils/dictionary';

const Wrapper = styled('div')`
  padding-top: 77px;
  .soc-banner {
    height: 98px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 19px;
    border-radius: 8px;
    background-color: ${color.blue};
    background: url(${banner}) 100% 100% no-repeat;
    @media (max-width: ${breakpoints.tl}) and (orientation: landscape) {
      background: linear-gradient(30deg, ${color.blue}, transparent);
    }

    @media (max-width: ${breakpoints.md}) and (min-width: ${breakpoints.sm}) and (max-height: ${breakpoints.tl}) and (min-height: ${breakpoints.md}) and (orientation: portrait) {
      background: linear-gradient(30deg, ${color.blue}, transparent);
    }
    div > img {
      height: 60px;
      width: 60px;
      position: absolute;
    }
    div {
      border-radius: 8px;
    }
    a {
      height: 60px;
      width: 60px;
      display: block;
      position: relative;

      @media (max-width: ${breakpoints.md}) and (orientation: landscape) {
        top: -10px;
      }
      img {
        height: 40px;
        width: 40px;
        left: 15px;
        top: 10px;
        position: absolute;

        @media (max-width: ${breakpoints.md}) and (orientation: portrait) {
          left: 8px;
        }
      }
      span {
        display: none;
      }
    }
    .soc-banner_content {
      padding: 0 25px 0 75px;

      @media (max-width: ${breakpoints.sm}) {
        width: calc(100% - 20px);
      }
      .soc-banner_add {
        font-size: 14px;
        text-transform: uppercase;
        color: #ffffff;
      }
      .soc-banner_mail {
        font-size: 22px;
        font-weight: bold;
        color: ${color.yellowLink};
      }
    }
  }
  .title {
    font-size: 19px;
    color: ${color.blue};
    padding-bottom: 24px;
    border-bottom: 2px solid ${color.lineGrey};
  }
  .top-list {
    padding-top: 20px;

    .top-list_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      width: 100%;
      padding: 0;
      position: relative;
      margin-bottom: 0;
      .top-list_num {
        color: #bec3cd;
        font-size: 45px;
        opacity: 0.2;
        position: absolute;

        @media (min-width: ${breakpoints.tl}) {
          left: -50%;

          @media (orientation: landscape) {
            left: -20px;
          }
        }
      }
      .top-list_item-text {
        font-size: 15px;
        padding-left: 15px;
        text-align: start;
        margin: 10px 20px;

        @media (max-width: ${breakpoints.md}) {
          width: 65%;
          margin: 5px 0;
          padding-left: 45px;
        }
        .name-game {
          text-transform: uppercase;
          margin-bottom: 3px;
        }
        .up-to {
          color: #bec3cd;
        }
      }
      .btn-play {
        font-size: 19px;
        text-align: center;
        color: #00c500;
        height: 36px;
        line-height: 36px;
        width: 80px;
        display: block;
        border-radius: 8px;
        border: 1.4px solid #00c500;
        cursor: pointer;
        transition-duration: 0.4s;
        &:hover {
          background-color: #00c500;
          color: ${color.white};
        }
      }
    }
  }

  @media (max-width: ${breakpoints.md}) {
    & .soc-banner {
      & .soc-banner_content {
        & .soc-banner_add {
          font-family: Kanit;
          font-size: 12px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
        }
      }
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    padding-top: 10px;
  }
`;

const TopTen = () => {
  const data = useStaticQuery(graphql`
    {
      allWordpressPage(filter: { wordpress_id: { eq: 2758 } }) {
        edges {
          node {
            wordpress_id
            acf {
              top_10_game_1 {
                description
                title
                url
              }
              top_10_game_2 {
                description
                title
                url
              }
              top_10_game_3 {
                description
                title
                url
              }
              top_10_game_4 {
                description
                title
                url
              }
              top_10_game_5 {
                description
                title
                url
              }
              top_10_game_6 {
                description
                title
                url
              }
              top_10_game_7 {
                description
                title
                url
              }
              top_10_game_8 {
                description
                title
                url
              }
              top_10_game_9 {
                description
                title
                url
              }
              top_10_game_10 {
                description
                title
                url
              }
            }
          }
        }
      }
    }
  `);
  const { allWordpressPage: { edges = [{}] } = {} } = data;
  const {
    node: {
      acf: {
        top_10_game_1,
        top_10_game_2,
        top_10_game_3,
        top_10_game_4,
        top_10_game_5,
        top_10_game_6,
        top_10_game_7,
        top_10_game_8,
        top_10_game_9,
        top_10_game_10,
      } = {},
    } = {},
  } = edges[0];
  const gameArr = [
    top_10_game_1,
    top_10_game_2,
    top_10_game_3,
    top_10_game_4,
    top_10_game_5,
    top_10_game_6,
    top_10_game_7,
    top_10_game_8,
    top_10_game_9,
    top_10_game_10,
  ];

  return (
    <Wrapper>
      <a href={dictionary.lineLink} target="_blank" className="soc-banner" rel="noopener noreferrer">
        <div style={{ position: 'absolute', height: '60px', width: '60px', backgroundColor: 'white' }}>
          <img src={line} alt="line" />
        </div>
        <span className="soc-banner_content">
          <div className="soc-banner_add">add Lnwasiagroup id</div>
          <div className="soc-banner_mail">{dictionary.lineWithAtSign}</div>
        </span>
      </a>
      <h2 className="title">10 เกมยอดนิยม</h2>
      <ul className="top-list">
        {gameArr?.map((game, i) => (
          <li className="top-list_item">
            <span className="top-list_num">{i + 1}.</span>
            <span className="top-list_item-text">
              <div className="name-game">{game.title || 'no data'}</div>
              <div className="up-to">{game.description || 'no data'}</div>
            </span>
            <Link to={validateLink(game.url ? game.url : '/')}>
              <span className="btn-play">คลิก</span>
            </Link>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};

export default TopTen;
